import { NativeComponents } from '@/lib/NativeComponents';

export const NativeElements = new NativeComponents();
